import { Container, Typography, ImageList, ImageListItem, Box, Button, Stack, Divider } from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function MasonryScenes(props) {
  const { photos, title } = props;
  const theme = useTheme();

  // Detectamos el tamaño de la pantalla
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Celulares (menor a 600px)
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Tablets o celulares grandes (600px - 900px)

  // 1. Calcular el número de columnas
  let columnas = 3; // Desktop por defecto
  if (isMobile) columnas = 1;
  else if (isTablet) columnas = 2;

  // 2. Calcular cuántas fotos mostrar
  let fotosVisibles = photos;
  if (isMobile) {
    fotosVisibles = photos.slice(0, 4); // En celular solo muestra las primeras 4
  } else if (isTablet) {
    fotosVisibles = photos.slice(0, 6); // En tablet muestra las primeras 6
  }

  return (
    <Container maxWidth="xl" sx={{ pb: 8, pt: 8 }}>
      <Stack spacing={3}>
        <Typography variant="h4" align="left" color="white" fontWeight="bold">
        {title}
        </Typography>
        <Divider style={{ background: 'white' }}/>
      </Stack>

      <Box sx={{ position: "relative", overflow: "hidden" }}>
        {/* Masonry grid */}
        <ImageList variant="masonry" cols={columnas} gap={12}>
        {fotosVisibles.map((item, index) => (
          <ImageListItem key={index}>
            <img
              src={item.src}
              alt={item.title || `photo-${index}`}
              loading="lazy"
              style={{ borderRadius: 12, width: '100%', display: 'block' }}
            />
          </ImageListItem>
        ))}
      </ImageList>

        {/* Gradient overlay */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "90%", // adjust fade size
            background:
              "linear-gradient(to bottom, rgba(43, 43, 43, 0) 0%, #111 100%)",
            pointerEvents: "none", // don’t block clicks
          }}
        />
      </Box>
    <Stack alignItems="center" justifyContent="center">
  <IconButton
      sx={{
        color: "black",                // icon color
        backgroundColor: "rgba(255, 255, 255, 1)", // optional subtle bg
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
        },
      }}
    >
      <KeyboardArrowDownIcon fontSize="large" />
    </IconButton>
</Stack>
    </Container>
  );
}

